import includes from 'lodash/includes';
import isString from 'lodash/isString';
import some from 'lodash/some';
import { DEFAULT_PER_PAGE_VALUES, DRIVER_LICENCE_MAP } from '@yme/common/constants';
import { ALL_DRIVER_LICENCE_KEY, DEALER_ID_SEPARATOR, DRIVER_LICENCE_CONFIG, PARAMS_KEYS, } from './constants';
export const checkPerPageCorrect = (perPage) => {
    return includes(DEFAULT_PER_PAGE_VALUES, perPage);
};
export const checkDriverLicenseCorrect = (driverLicense) => {
    return some(DRIVER_LICENCE_CONFIG, (item) => item.value === driverLicense);
};
export const checkAllParamsCorrect = ({ page, perPage, driverLicense, isShowDriverLicenseFilter, }) => {
    return isShowDriverLicenseFilter
        ? page &&
            checkPerPageCorrect(perPage) &&
            driverLicense &&
            checkDriverLicenseCorrect(driverLicense)
        : page && checkPerPageCorrect(perPage);
};
export const getUnitsPerPage = (data, currentPage, itemsPerPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
};
export const filterByDriverLicense = (units, filter) => {
    const availableLicenses = DRIVER_LICENCE_MAP[filter];
    if (availableLicenses) {
        return units.filter((unit) => includes(availableLicenses, unit.driverLicense[0]));
    }
    return availableLicenses;
};
export const getFilteredProductsByLicence = (activeLicence, data) => {
    return activeLicence !== ALL_DRIVER_LICENCE_KEY && filterByDriverLicense(data, activeLicence);
};
export const getDriversLicenseConfig = (AllDriverLabel) => {
    DRIVER_LICENCE_CONFIG[0].label = AllDriverLabel;
};
export const convertIframeParamToBoolean = (isIframe) => isIframe === 'true';
export const convertDealerIdParamToString = (dealerId) => isString(dealerId) ? dealerId : '';
export const getDealerIdFromUrlList = (dealerId) => dealerId ? dealerId.split(DEALER_ID_SEPARATOR) : [];
export const getUrlWithTestRideMode = ({ url, dealerId, isIframe }) => {
    try {
        const urlWithParams = new URL(url, window.location.origin);
        if (dealerId) {
            urlWithParams.searchParams.set(PARAMS_KEYS.dealerId, dealerId);
        }
        if (isIframe) {
            urlWithParams.searchParams.set(PARAMS_KEYS.isIframe, `${isIframe}`);
        }
        return `${urlWithParams.pathname}${urlWithParams.search}`;
    }
    catch (error) {
        return '';
    }
};
